// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetAssets (params?: {}): Promise<Dict>;
    publicGetIndices (params?: {}): Promise<Dict>;
    publicGetProducts (params?: {}): Promise<Dict>;
    publicGetProductsSymbol (params?: {}): Promise<Dict>;
    publicGetTickers (params?: {}): Promise<Dict>;
    publicGetTickersSymbol (params?: {}): Promise<Dict>;
    publicGetL2orderbookSymbol (params?: {}): Promise<Dict>;
    publicGetTradesSymbol (params?: {}): Promise<Dict>;
    publicGetStats (params?: {}): Promise<List>;
    publicGetHistoryCandles (params?: {}): Promise<Dict>;
    publicGetHistorySparklines (params?: {}): Promise<Dict>;
    publicGetSettings (params?: {}): Promise<Dict>;
    privateGetOrders (params?: {}): Promise<Dict>;
    privateGetOrdersOrderId (params?: {}): Promise<Dict>;
    privateGetOrdersClientOrderIdClientOid (params?: {}): Promise<Dict>;
    privateGetProductsProductIdOrdersLeverage (params?: {}): Promise<Dict>;
    privateGetPositionsMargined (params?: {}): Promise<Dict>;
    privateGetPositions (params?: {}): Promise<Dict>;
    privateGetOrdersHistory (params?: {}): Promise<Dict>;
    privateGetFills (params?: {}): Promise<Dict>;
    privateGetFillsHistoryDownloadCsv (params?: {}): Promise<Dict>;
    privateGetWalletBalances (params?: {}): Promise<Dict>;
    privateGetWalletTransactions (params?: {}): Promise<Dict>;
    privateGetWalletTransactionsDownload (params?: {}): Promise<Dict>;
    privateGetWalletsSubAccountsTransferHistory (params?: {}): Promise<Dict>;
    privateGetUsersTradingPreferences (params?: {}): Promise<Dict>;
    privateGetSubAccounts (params?: {}): Promise<Dict>;
    privateGetProfile (params?: {}): Promise<Dict>;
    privateGetRateLimitsQuota (params?: {}): Promise<Dict>;
    privateGetHeartbeat (params?: {}): Promise<Dict>;
    privateGetDepositsAddress (params?: {}): Promise<Dict>;
    privatePostOrders (params?: {}): Promise<Dict>;
    privatePostOrdersBracket (params?: {}): Promise<Dict>;
    privatePostOrdersBatch (params?: {}): Promise<Dict>;
    privatePostProductsProductIdOrdersLeverage (params?: {}): Promise<Dict>;
    privatePostPositionsChangeMargin (params?: {}): Promise<Dict>;
    privatePostPositionsCloseAll (params?: {}): Promise<Dict>;
    privatePostWalletsSubAccountBalanceTransfer (params?: {}): Promise<Dict>;
    privatePostHeartbeatCreate (params?: {}): Promise<Dict>;
    privatePostHeartbeat (params?: {}): Promise<Dict>;
    privatePostOrdersCancelAfter (params?: {}): Promise<Dict>;
    privatePostOrdersLeverage (params?: {}): Promise<Dict>;
    privatePutOrders (params?: {}): Promise<Dict>;
    privatePutOrdersBracket (params?: {}): Promise<Dict>;
    privatePutOrdersBatch (params?: {}): Promise<Dict>;
    privatePutPositionsAutoTopup (params?: {}): Promise<Dict>;
    privatePutUsersUpdateMmp (params?: {}): Promise<Dict>;
    privatePutUsersResetMmp (params?: {}): Promise<Dict>;
    privatePutUsersMarginMode (params?: {}): Promise<Dict>;
    privatePutUsersTradingPreferences (params?: {}): Promise<Dict>;
    privateDeleteOrders (params?: {}): Promise<Dict>;
    privateDeleteOrdersAll (params?: {}): Promise<Dict>;
    privateDeleteOrdersBatch (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
